import { Table } from 'react-bootstrap';
import { EmptyDataRow } from '../UIExtentions/TableUtilities';
import { ServersTableRow } from './ServersTableRow';
import { IServerAdditionalInfo } from '../../api/models';

export interface Server {
    id: number;
    name: string;
    environment?: string;
    lastDiscoveredTimestamp?: string;
    operatingSystemType: string;
    additionalInfo?: IServerAdditionalInfo;
}

export interface ServersTableProps {
    data: Server[];
}

const ServersTable = (props: ServersTableProps) => {
    return (
        <div className="table-wrapper">
            <Table striped={true} className="table-fixed-header">
                <thead className="thead-white">
                    <tr>
                        <th scope="col" className="col-1">
                            <i className="fa fa-star"></i>
                        </th>
                        <th scope="col" className="col-4">
                            Name
                        </th>
                        <th scope="col" className="col-2">
                            Environment
                        </th>
                        <th scope="col" className="col-2">
                            Last Discovery
                        </th>
                        <th scope="col" className="col-2">
                            Operating System
                        </th>
                        <th scope="col" className="col-1">
                            Actions
                        </th>
                    </tr>
                </thead>
                <tbody>
                    {props.data.length > 0 ? (
                        props.data.map(function (d: Server, i: number) {
                            return (
                                <ServersTableRow
                                    key={'server-' + d.id}
                                    name={d.name}
                                    environment={d.environment}
                                    lastDiscoveredTimestamp={d.lastDiscoveredTimestamp}
                                    osType={d.operatingSystemType}
                                    osName={d.additionalInfo?.operatingSystemName}
                                    osVersion={d.additionalInfo?.operatingSystemVersion}
                                />
                            );
                        })
                    ) : (
                        <EmptyDataRow colSpan={5} />
                    )}
                </tbody>
            </Table>
        </div>
    );
};

export default ServersTable;
